<template>
    <v-container class="app-page-container">
        <v-card class="shadow-none app-page-card">
            <v-card-title class="border-b">
                Confirmation attempt
            </v-card-title>
            <v-card-text>
                <v-flex xs12>
                    <v-icon v-if="!accepted" class="d-flex justify-center mt-8 mb-2" color="red" x-large>report_gmailerrorred</v-icon>
                    <v-icon v-if="accepted" class="d-flex justify-center mt-8 mb-2 material-icons-outlined" color="green" x-large>verified</v-icon>
                    <p align="center" v-if="feedback">{{feedback}}</p>
                    <v-layout justify-center class="mt-8 mb-3" v-if="accepted">
                        <v-btn small class="pl-2 pr-3 py-4 border-radius-lg btn-primary shadow-none" @click="goToPriscilla()">
                            <v-icon dense class="mr-2">arrow_circle_right</v-icon> Go to Priscilla
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-container>    
</template>

<script>
import axios from '../../axios-auth.js'

  export default {
    data() {
      return {
          feedback : null,
          accepted : false,
          grant_type:"password",
          client_id: "2",
          client_secret: "iQuGUAzqc187j7IKQ94tTVJAywHCAzYBGAMTxEtr",
      }
    },
    methods : {
        initData() {
            let data = {
                mail : this.$route.params.mail,                
                token : this.$route.params.token                
            }            
            // console.log(data)
        axios.post('/confirm', data, this.$store.getters.getAxiosConfig)
          .then((res) => {
              // console.log(res.data)
              if (res.data.message == 'OK') {                  
                  // token instead of pwd to this user
                  // try login
                  const _mytemppwd = res.data.token
                  const data = {
                    email: this.$route.params.mail,
                    password: _mytemppwd,
                    grant_type: this.grant_type,
                    client_id: this.client_id,
                    client_secret: this.client_secret,
                    username: this.$route.params.mail
                  }

                  axios.post('/oauth/token', data, this.$store.getters.getAxiosConfig)
                    .then(res => {        
                        // TOKEN TO LOCAL STORAGE
                        localStorage.setItem('token', res.data.access_token) 
                        // registration finished
                        const data = {
                            email: this.$route.params.mail,
                            password: _mytemppwd
                        }
                        axios.post('/finishreg', data, this.$store.getters.getAxiosConfig) 
                        .then(res => {        
                            if (res.data.message == 'OK') this.accepted = true
                            this.feedback = res.data.message + ': '+ res.data.description 
                        })
                        .catch(error => {
                                this.$store.commit('setFeedback', 'finishreg: '+ error)
                        })
                    })
                    .catch(error => {
                            this.$store.commit('setFeedback', 'token: ' + error)
                    })
              } else {
                  this.feedback = res.data.description
              }
          })
          .catch(error => {
                this.$store.commit('setFeedback', 'confirm: ' + error)
                
          })

         localStorage.removeItem('confirm')

        },
        goToPriscilla() {
            this.$store.dispatch('tryAutologin')
            this.$router.push({name:'dashboard'})  
        }
    },
    mounted() {
      this.initData()
    }
  }

</script>